export const restrictedDomainForMoreModel = [
    'farmersdaughterwisco.com',
    'therealslimswaney.com',
    'ellieempressvip.com',
    'iamavafiore.com',
    'alicemonachella.com',
    'pypersplayhouse.com',
    'olyriaroyvip.com',
    'anamontanaworld.com',
    'daisypascual.com',
    'glolabhawaii.com',
    'mariahhardcore.com',
    'meaganxo.com',
    'metishaxo.com',
    'shamwowexclusive.com',
    'therealbella.com',
    'victoriasinclairvip.com',
    'yourdestinyunlocked.com'
]
